export default () =>
  import(/* webpackChunkName: 'coffee/activities/fission/slot' */ './Slot');
